import { ApiSchema } from "@/modules/api";

export type SpaceAccountFeatureFlagsModelData =
  ApiSchema["FeatureFlagsSyncModelDataResponseSchema"];

export type SpaceAccountPostHogFeatureFlagIds =
  | "theme-switcher"
  | "calendar-integration"
  | "one-click-import";

export enum SpaceAccountPostHogFeatureFlagChatZeroStateVariant {
  AskAboutYourNotes = "ask_about_your_notes_001",
  Onboarding = "onboarding_001",
}
